import React from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom'
import HintPopover from "../../../gd-ui/hint-popover/hint-popover";
import Popover from "../../gd-popover/popover";


// use .show-popover class to keep visible when popup menu open !!!!

export default class PopupMenuButton extends React.Component<any,any> {

    public popoverKeyDownListener?      : any // need fix potom

    static propTypes = {

        btnComponent: PropTypes.func,                // pass component if icon class is not enough
        menuComponent: PropTypes.func.isRequired,    // component with menu - skin gd-popup-menu-btn
        menuParams: PropTypes.object.isRequired,     // menu component params - vaznaya shtuka (!) dlya handlers ?
        hint: PropTypes.string,                      // optional hint for the btnComponenr

        popoverClass: PropTypes.string,
        popoverContentClass: PropTypes.string,
        popoverStyles: PropTypes.object,
        domElementId: PropTypes.string,              // set dom element id used in tour

        attachment: PropTypes.string,
        targetAttachment: PropTypes.string,
        attachmentType: PropTypes.oneOf(['horizontal','vertical']),
        offset: PropTypes.string,
        arrowsVersion: PropTypes.oneOf([1,2]),

        outsideClickIgnoreClasses: PropTypes.any,     // string or array of strings, nodes classes clicks on which are ignored
        insideClickIgnoreClasses: PropTypes.any,     // string or array of strings, nodes classes clicks on which are ignored
        clickOutsideDelay: PropTypes.number,

        disabled: PropTypes.bool,                     // if true - no click + disabled class

        showPopover     : PropTypes.bool,             // if true - popover shown by default used when multiselect in popover (checkboxes)

        // callback
        onTogglePopover: PropTypes.func
    };

    static defaultProps = {
        disabled        : false,
        attachment      : "top right",
        targetAttachment: "bottom right",
        attachmentType  : "horizontal",
        offset          : "0 -10",
        arrowsVersion   : 1,
    }

    constructor(props:any) {
        super(props)

        this.state = {
            showPopover: !!(this.props.showPopover)
        }
    }

    preventPropagation = (e:React.SyntheticEvent) => {e.stopPropagation();};

    onPopoverKeyDown = (e:React.SyntheticEvent) => {
        if (this.popoverKeyDownListener) this.popoverKeyDownListener.onPopoverKeyDown(e);
    }

    onClickOutside = (e?:React.SyntheticEvent) => {
        if(e && this.props.outsideClickIgnoreClasses && gd.utils.Dom.findNodeByClassName(e.target, this.props.outsideClickIgnoreClasses)) return

        this.hidePopover()
    }

    hidePopover = () => {
        const { onTogglePopover } = this.props;
        this.setState({showPopover: false},
            ()=>{if (onTogglePopover) onTogglePopover(false);});
    };

    togglePopover = (e:React.SyntheticEvent) => {

        e.stopPropagation();

        if (this.props.disabled) return;

        if(this.props.insideClickIgnoreClasses && gd.utils.Dom.findNodeByClassName(e.target, this.props.insideClickIgnoreClasses)) return;

        const showPopover = !this.state.showPopover;
        this.setState({
            showPopover: showPopover
        },()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(showPopover);
        });

    };

    onPopoverKeyDownListener = (listener:callback) => {
        this.popoverKeyDownListener = listener;
    }

    renderPopover = () => {
        const MenuComponent = this.props.menuComponent;

        return (
            <Popover popoverClass       = {Classes("gd-popup-menu", this.props.popoverClass)}
                     className          = {this.props.popoverContentClass}
                     style              = {this.props.popoverStyles}
                     attachment         = {this.props.attachment}
                     targetAttachment   = {this.props.targetAttachment}
                     attachmentType     = {this.props.attachmentType}
                     offset             = {this.props.offset}
                     arrowsVersion      = {this.props.arrowsVersion}
                     onKeyDown          = {this.onPopoverKeyDown}
                     onClickOutside     = {this.onClickOutside}
                     clickOutsideDelay  = {this.props.clickOutsideDelay}
                     getTargetFunc      = {()=>findDOMNode(this)}>

                <MenuComponent hidePopover={this.hidePopover} menuParams={this.props.menuParams} onPopoverKeyDownListener={this.onPopoverKeyDownListener}/>

            </Popover>
        );

    };

    render() {
        const classes = Classes("gd-popup-menu-btn", this.props.className, {
            "show-popover": this.state.showPopover,
            'disabled': this.props.disabled,
        });

        return (
            <div className={classes} style={this.props.style} onClick={this.togglePopover} id={this.props.domElementId}>
                {this.props.btnComponent && this.props.btnComponent(this.state, this.props)}
                {this.props.children}
                {this.props.hint && !this.state.showPopover && <HintPopover parent={this} hint={this.props.hint} />}
                {this.state.showPopover && this.renderPopover()}
            </div>
        );

    }
}

